import React from 'react'
import styled from 'styled-components'

export interface OfficeViewerProps {
  src: string
  ui?: boolean
  onLoad?: () => void
}

const IFrame = styled.iframe`
  height: 100%;
  width: 100%;
  border: none;
`

const WITH_UI = 'https://view.officeapps.live.com/op/view.aspx'
const WITHOUT_UI = 'https://view.officeapps.live.com/op/embed.aspx'


export const OfficeViewer: React.VFC<OfficeViewerProps> = ({
  src,
  onLoad,
  ui = true
}) => {
  const viewerUrl = src.endsWith('.txt') ? src : `${ui ? WITH_UI : WITHOUT_UI}?src=${src}`
  return <IFrame src={viewerUrl} onLoad={onLoad} />
}
